var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 87,
    viewBox: "0 0 108 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.5 86.7V60.9C61.5 44.7 65.3 31.5 72.9 21.3C80.7 10.9 92.2 4.09999 107.4 0.899991V20.4C100.6 22 95.2 25 91.2 29.4C87.2 33.6 84.6 38.7 83.4 44.7H101.4V86.7H61.5ZM0.900002 86.7V60.9C0.900002 44.7 4.7 31.5 12.3 21.3C20.1 10.9 31.5 4.09999 46.5 0.899991V20.4C39.7 22 34.3 25 30.3 29.4C26.3 33.6 23.7 38.7 22.5 44.7H40.5V86.7H0.900002Z",
    fill: "#B1DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientQuote);
export default __webpack_public_path__ + "static/media/client-quote.034527c4d8194b0026e913e7828f8383.svg";
export { ForwardRef as ReactComponent };